import { memo, useCallback } from "react";
import { ReactSVG } from "react-svg";
import { Button } from "ui/components/Button/Button";
import { classNames, formatCurrency } from "helpers";
import { CHANNEL_CONFIG, DEFAULT_CHANNEL_CONFIG } from "services/api/sales/listings/consts";
import { SalesChannel } from "services/api/sales/channels/types";

// Per-kanal naknada (placeholder dok BE nema fees endpoint).
const CHANNEL_FEE_TEXT: Record<string, string> = {
  marketplace: "Besplatno",
  njuskalo: "€4,90 / oglas",
  index_oglasi: "Besplatno",
  plavi_oglasnik: "Naknade vrijede",
  website: "Besplatno",
};

interface Props {
  channel: SalesChannel;
  price: number | null;
  onAdjust: (channelId: string, currentPrice: number | null, channelName: string) => void;
  /** Redak bez cijene kad korak ne prolazi — obojan umjesto poruke iznad liste. */
  hasError?: boolean;
}

const ChannelPriceRow: React.FC<Props> = ({ channel, price, onAdjust, hasError }) => {
  const cfg = CHANNEL_CONFIG[channel.code] || DEFAULT_CHANNEL_CONFIG;

  const handleAdjust = useCallback(
    () => onAdjust(channel.id, price, channel.name),
    [channel.id, channel.name, onAdjust, price]
  );

  return (
    <div
      className={classNames(
        "border rounded-sm p-3",
        hasError ? "border-red-500 bg-red-50" : "border-slate-200 bg-white"
      )}
    >
      <div className="flex items-center gap-3">
        <span
          className={classNames(
            "flex items-center justify-center w-10 h-10 rounded-full flex-shrink-0",
            cfg.badge.bg,
            cfg.badge.text
          )}
        >
          <ReactSVG src={cfg.icon} className="w-5 h-5 [&_svg]:w-5 [&_svg]:h-5" />
        </span>

        <div className="flex-1 min-w-0">
          <div className="font-semibold text-slate-800 truncate">{channel.name}</div>
          <div className="text-xs text-slate-500">
            {CHANNEL_FEE_TEXT[channel.code] ?? "—"}
          </div>
        </div>
        <div className="flex items-center gap-4">
          <div className="font-bold text-lg text-slate-800 whitespace-nowrap">
            {price != null ? formatCurrency.format(price) : "—"}
          </div>

          <Button variant="outlined" size="small" onClick={handleAdjust}>
            Promjeni cijenu
          </Button>
        </div>
      </div>
    </div>
  );
};

export default memo(ChannelPriceRow);
